import React from 'react';
import './App.css';
import Loading from './component/common/loading'
import TabPage from './contenter/TabPage';
import { connect } from 'react-redux';

class App extends React.Component{
  // eslint-disable-next-line no-useless-constructor
  constructor(props){
    super(props);
  }
  
  render () {
    return  <div className="APP">
      <TabPage {...this.props} />
    <Loading/>
  </div>
  }
}
export default connect(state => {
  return state;
})(App);
